module.exports = __webpack_public_path__ + "img/logo_baddeckenstedt.5537e1f8.png";